module.exports = __webpack_public_path__ + "img/sb10.c3d65a31.png";